import React, { Component } from 'react';

class ChangeState extends Component{
    state = {
        isClicked: false
    }

    handleClicked = ()=>{
        this.setState({ 
            isClicked : true
         })
    }

    render(){
        const { isClicked } = this.state;
        const { active, inactive } = styles;
        return(
            <span style={ isClicked ? active : inactive }
            onClick={this.handleClicked}
            >
             {this.props.children}
            </span>
        )
    }
};

const styles = {
    active: {
      color: "red"
    },
    inactive: {
        color: "black",
    }
}

export { ChangeState };


// WEBPACK FOOTER //
// ./src/components/common/changeState.js